import axios from 'axios';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { Button, Loader } from 'semantic-ui-react';

interface PropTypes {
  setShowActions: (e: any) => void;
  searchTypeId: number;
  propertyId: number;
  oldPropertyId: number;
  setDocumentKey?: () => void;
}

export const AttachmentsFromOtherLots = (props: PropTypes) => {
  const [loading, setLoading] = useState(false);
  const [numberOfAttachments, setNumberOfAttachments] = useState(0);

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `/api/property/GetNumberOfAttachments?propertyId=${props.oldPropertyId}&searchTypeId=${props.searchTypeId}`
      )
      .then(({ data }) => {
        setNumberOfAttachments(data);
        setLoading(false);
      });
  }, []);

  const getAttachmentsForProperty = async () => {
    await axios.post('/api/property/HandleAttachmentsOfProperty', {
      searchTypeId: props.searchTypeId,
      propertyId: props.propertyId,
      oldPropertyId: props.oldPropertyId,
    });
  };

  return loading ? (
    <Loader inline active />
  ) : numberOfAttachments === 0 ? (
    <div>No Attachments</div>
  ) : (
    <React.Fragment>
      <div style={{ marginTop: 8 }}>{numberOfAttachments} attachment(s)</div>
      <div style={{ marginTop: 8, display: 'flex', gap: 5, alignItems: 'center' }}>
        <div>Include</div>
        <Button
          onClick={async () => {
            props.setShowActions(false);
            await getAttachmentsForProperty();
            props.setDocumentKey && props.setDocumentKey();
          }}
          basic
          color="green"
          content="Yes"
        />
        <Button
          onClick={() => {
            props.setShowActions(false);
          }}
          basic
          color="red"
          content="No"
        />
      </div>
    </React.Fragment>
  );
};
